import React from 'react';
import PropTypes from 'prop-types';
import detect from 'browser-detect';
import { useTranslation } from 'react-i18next';

import Typography from '../Typography';
import { Icons } from '@ohif/ui-next';

const Link = ({ href, children, showIcon = false }) => {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      <Typography
        variant="subtitle"
        component="p"
        color="primaryActive"
        className="flex items-center"
      >
        {children}
        {!!showIcon && <Icons.ExternalLink className="ml-2 w-5 text-white" />}
      </Typography>
    </a>
  );
};

const Row = ({ title, value, link }) => {
  return (
    <div className="mb-4 flex">
      <Typography
        variant="subtitle"
        component="p"
        className="w-48 text-white"
      >
        {title}
      </Typography>

      {link ? (
        <Link href={link}>{value}</Link>
      ) : (
        <Typography
          variant="subtitle"
          component="p"
          className="w-48 text-white"
        >
          {value}
        </Typography>
      )}
    </div>
  );
};

const AboutModal = ({ buildNumber, versionNumber, commitHash }) => {
  const { t } = useTranslation('AboutModal');

  const renderRowTitle = title => (
    <div className="mb-3 border-b-2 border-black pb-3">
      <Typography
        variant="inherit"
        color="primaryLight"
        className="text-[16px] font-semibold !leading-[1.2]"
      >
        {title}
      </Typography>
    </div>
  );
  return (
    <div>
      {renderRowTitle(t('Non Diagnostic Viewer Requirements'))}
      <div className="flex flex-col">
        <Row
          title={t('RAM')}
          value="8GB"
        />
      </div>
      {renderRowTitle(t('Minimum Requirements'))}
      <div className="flex flex-col">
        <Row
          title={t('RAM')}
          value="8GB"
        />
        <Row
          title={t('Graphics Card')}
          value="Dedicated Graphics Card/External"
        />
      </div>
      {renderRowTitle(t('Required Requirements'))}
      <div className="flex flex-col">
        <Row
          title={t('RAM')}
          value="16GB"
        />
        <Row
          title={t('Graphics Card')}
          value="NVIDIA GeForce GTX 1650 Super or the AMD Radeon RX 5500 XT"
        />
      </div>
    </div>
  );
};

AboutModal.propTypes = {
  buildNumber: PropTypes.string,
  versionNumber: PropTypes.string,
};

export default AboutModal;
